import React from 'react'
import { T } from '@transifex/react'
import { useAppSelector } from '../../../state/hooks'
import { selectChange } from '../../../state/slices/currentSale/currentSaleSlice'
import { hasChange } from '../../../functions/payments'
import { getChangeAmountForDisplay } from '../../../functions/sale'
import { useFormatCurrencyValue } from './useFormatCurrencyValue'
export const ChangeAmountSection = () => {
  const change = useAppSelector(selectChange)
  const saleHasChange = hasChange(change)
  const formatCurrencyValue = useFormatCurrencyValue()

  if (!saleHasChange) {
    return null
  }
  const changeAmount = getChangeAmountForDisplay({ change })
  return (
    <section className="sale-summary-section sale-summary-section--indent sale-summary-section--change sale-summary-section-divider-top">
      <ul className="sale-summary-list">
        <li className="sale-summary-line">
          <div className="sale-summary-line-item sale-summary-line-item--label">
            <T
              _str="Change"
              _context="Label for change amount on sale summary panel"
            />
          </div>
          <div className="sale-summary-line-item sale-summary-line-item--value">
            {formatCurrencyValue(changeAmount)}
          </div>
        </li>
      </ul>
    </section>
  )
}
